import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { testHubSpotProductionIntegration } from '@/lib/hubspotProductionTest';

/**
 * Manual OG01 CRM acceptance test. This route is deliberately Preview-only.
 * Does not display tokens or run automatically on page load.
 */
export default function HubSpotAcceptance() {
  const { user } = useAuth();
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState<{ success: boolean; error?: string; hubspotId?: string; data?: { action?: string } } | null>(null);
  const preview = window.location.hostname.endsWith('.review-lab-optimax.pages.dev');
  const run = async () => {
    if (!user || !preview || running) return;
    setRunning(true);
    try { setResult(await testHubSpotProductionIntegration(user)); }
    finally { setRunning(false); }
  };
  if (!preview) return <main style={{ padding: '2rem' }}>Acceptance tests are unavailable outside Cloudflare Preview.</main>;
  return <main style={{ maxWidth: 680, margin: '3rem auto', padding: '1.5rem', fontFamily: 'system-ui' }}>
    <h1>OG01 ↔ HubSpot integration acceptance</h1>
    <p>This is a Preview-only, manually triggered test. It synchronises your signed-in OG01 account to the real HubSpot CRM; it does not send emails or create purchases.</p>
    <p>Signed in as: <strong>{user?.email || 'No authenticated account'}</strong></p>
    <button onClick={run} disabled={!user || running} style={{ padding: '0.75rem 1rem', border: '1px solid', borderRadius: 6 }}>
      {running ? 'Testing…' : 'Sync my internal test contact'}
    </button>
    {result && <section aria-live="polite" style={{ marginTop: 18 }}>
      <h2>{result.success ? 'Sync succeeded' : 'Sync failed'}</h2>
      <p>{result.success
        ? `HubSpot contact ${result.data?.action || 'synchronised'}. ID: ${result.hubspotId || 'unknown'}`
        : (result.error || 'Unknown error')}</p>
      <p>Check HubSpot for the OG01 Business Unit and confirm only one contact exists.</p>
    </section>}
  </main>;
}
